import { DeliveryMethod } from 'apps/shared/scripts/__generated__/graphql.generated';

import { FormValues } from './types';

export const FORM_FIELDS = {
  DELIVERY_METHOD: {
    name: 'deliveryMethod',
    label: 'Delivery Method',
  } as const,
  RECIPIENT_EMAIL: {
    name: 'recipientEmail',
    label: 'Recipient Email',
    description: 'Where the final card should be sent to.',
  } as const,
};

export const DEFAULT_VALUES: FormValues = {
  [FORM_FIELDS.DELIVERY_METHOD.name]: DeliveryMethod.Manual,
  [FORM_FIELDS.RECIPIENT_EMAIL.name]: '',
};
